import "./DressCodeSection.scss";

export const DressCodeSection = () => {
  return (
  <section id="dress-code" className="dress-code-section">
    <div className="dress-code-content">
      <div className="dress-code-header">
        <h2>Dress Code</h2>

        <p className="dress-code-intro">
          Amennyiben szeretnéd jelezni, hogy melyik táborba tartozol,
          az öltözékedet ahhoz igazíthatod.
        </p>

        <p className="dress-code-intro">
          Ha van kedved és a <strong>menyasszony vendégtáborát</strong>{" "}
          erősíted, válassz valamilyen <strong>rózsaszín</strong> ruhát
          vagy kiegészítőt – akár egy selyemszalag a zakóra tűzve is
          bőven megteszi. Ha pedig a{" "}
          <strong>vőlegény táborát</strong> erősíted, válassz valami{" "}
          <strong>kéket</strong>!
        </p>

        <p className="dress-code-intro">
          Természetesen ez nem kötelező, gyere, amiben jól érzed
          magad, de kérünk, a <strong>hófehér ruhádat hagyd
          otthon.</strong> 
        </p>

        <p className="dress-code-intro">
          A helyszínünkön a polgári szertartás füves részen lesz, így
          számolj ezzel is, ha magassarkún gondolkozol. Viszont a
          kedvenc bulicipődet se hagyd otthon, mert{" "}
          <strong>hajnalig fogunk táncolni!</strong> 
        </p>
      </div>
      </div>
    </section>
  );
};